import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { OrganizationProfile, OrganizationProfileUpdateParams } from './organization-profile';

/**
 * Service for controlling organization data
 */
@Injectable()
export class OrganizationProfileService {

  /** Sets language of app */
  public language = 'en';

  /** API Url */
  private readonly apiUrl = `${environment.apiBaseUrl}/admin`;

  /**
   * Clears cache on login and logout
   */
  public constructor(@Inject(HttpClient) private readonly http: HttpClient) {}

  /**
   * Gets timezones object
   */
  public getTimezones(): Observable<string[]> {
    return of(moment.tz.names());
  }

  /**
   * Gets current Organization
   * @returns Organization
   */
  public getCurrentOrganization(): Observable<OrganizationProfile> {
    const url = `${this.apiUrl}/settings`;
    const req = this.http.get<OrganizationProfile>(url);

    return req;
  }

  /**
   * Updates current Organization
   * @param organization Takes the editable settings to save
   * @returns Organization
   */
  public updateCurrentOrganizationProfile(organization: OrganizationProfileUpdateParams): Observable<OrganizationProfile> {
    const url = `${this.apiUrl}/settings`;
    const req = this.http.put<OrganizationProfile>(url, organization);

    return req;
  }

}
